import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import VideoPlayer from 'components/VideoPlayer';

const BackgroundVideo = ({ asset }) => {
  return (
    <div className="BackgroundVideo">
      <VideoPlayer url={get(asset, ['file', 'url'])} playing muted loop playsinline />
      <style jsx>
        {`
          .BackgroundVideo {
            width: 100%;
            height: 100%;
            order: 1;
          }
        `}
      </style>
      <style jsx global>
        {`
          .PageSectionAssetDecoratedCarousel .BackgroundVideo .VideoPlayer {
            padding-top: 0;
            width: 100%;
            height: 100%;
          }

          .BackgroundVideo .VideoPlayer__player > video {
            object-fit: cover;
          }
        `}
      </style>
    </div>
  );
};

BackgroundVideo.propTypes = {
  asset: PropTypes.shape({
    file: PropTypes.shape({
      cloudinaryUrl: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default BackgroundVideo;
